import { ItemsPerPage } from '@billy/design-system'
import { useMemo } from 'react'

import { useImportedInvoicesList } from './useImportedInvoicesList'

interface UseHasImportedInvoicesResult {
  hasImportedInvoices: boolean
  isLoading: boolean
}

// Unfiltered (no period/search): decides onboarding empty vs list shell — filtered totals must not.
export const useHasImportedInvoices = (): UseHasImportedInvoicesResult => {
  const { invoices, isLoading, isSuccess } = useImportedInvoicesList({
    page: 1,
    pageSize: 1 as ItemsPerPage,
  })

  return useMemo(
    () => ({
      hasImportedInvoices: isSuccess && invoices.length > 0,
      isLoading,
    }),
    [invoices.length, isLoading, isSuccess],
  )
}
